import landing from '@/locales/hn/landing'
import currency from '@/locales/hn/currency'
import resultOrder from '@/locales/hn/result-order'
import invoice from '@/locales/hn/invoice'
import genericError from '@/locales/hn/generic-error'
import maintenance from '@/locales/hn/maintenance'

export default {
  landing,
  currency,
  resultOrder,
  invoice,
  genericError,
  maintenance
}
